import useStripEhQueryParams from './useStripEhQueryParams';

const useResetEhModel = () => {
  useStripEhQueryParams();
};

export default useResetEhModel;
